import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-landing-one',
  templateUrl: './agency-landing-one.component.html',
  styleUrls: ['./agency-landing-one.component.scss']
})
export class AgencyLandingOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
